<template>
    <div class="components-view" @click="resetDropdownControls">
        <pre-loader-component :visible="loading"></pre-loader-component>
        <main v-if="!loading" class="current-component">
            <scroll-hide-nav>
                <h2 v-if="!notEmpty">Ты еще не проявил активность, поэтому тут пусто</h2>
                <div class="dashboard-grid">
                    <div class="col" >
                        <dashbord-dropdown v-for="(list,index) in rightLists"
                                :title="list.title"
                                :list-type="list.id"
                                :list-mutation="list.mutation"
                                :opened="(!index)"
                                :draggable="list.draggable"
                                :key="index"
                                :isMobile="isMobile">
                        </dashbord-dropdown>
                    </div>
                    <div class="col" >
                        <dashbord-dropdown v-for="(list,index) in leftLists"
                                           :title="list.title"
                                           :list-type="list.id"
                                           :list-mutation="list.mutation"
                                           :draggable="list.draggable"
                                           :key="index"
                                           :isMobile="isMobile"
                                           :opened="!index && !isMobile">
                        </dashbord-dropdown>
                    </div>
                </div>
            </scroll-hide-nav>
        </main>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import DashbordDropdown from "./DashbordDropdown";
    import PreLoaderComponent from "../common/PreLoader";
    import ScrollHideNav from "../common/ScrollHideNav";

    export default {
        name: 'main-page-component',
        components: {
            ScrollHideNav,
            PreLoaderComponent,
            DashbordDropdown,
        },
        data() {
            return {
                isMobile: false,
                rightLists: [
                    {
                        title: 'Избранное',
                        id: 'favorite',
                        mutation: 'setFavorite',
                        draggable: true
                    },
                    {
                        title: 'Курсы',
                        id: 'training',
                        mutation: 'setTraining',
                        draggable: true
                    },

                ],
                leftLists: [
                    {
                        title: 'Последнее просмотренное',
                        id: 'history',
                        mutation: 'setHistory',
                        draggable: false
                    },
                    {
                        title: 'Тесты',
                        id: 'tests',
                        mutation: 'setTests',
                        draggable: true
                    },

                ],
                loading: true,
            }
        },
        computed : {
            half() {
               return Math.round(this.lists.length / 2)
            },
            ...mapState({
                favorite: state => state.main.favorite,
                history: state => state.main.history,
                training: state => state.main.training,
                tests: state => state.main.tests,
                active: state => state.main.activePost,
            }),
            notEmpty() {
                return this.favorite.length || this.history.length || this.tests.length || this.training.length
            }
        },
        methods: {
            ...mapActions('main', [
                'getFavoriteItems'
            ]),
            ...mapMutations('main', [
                'setControlsVisibility',
            ]),
            resetDropdownControls() {
                this.setControlsVisibility(null)
            },
            resizeHandler() {
                this.isMobile = document.body.clientWidth <= 780;
            },
        },
        created() {
            this.$store.commit('setAppClass', 'home-component');
            this.getFavoriteItems().then(() => {
                this.loading = false
            });
            window.addEventListener("resize", this.resizeHandler);
            this.resizeHandler();
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeHandler);
        },
    }
</script>


<style scoped>

</style>
